var map = {
	"./core/LogoDark": [
		6806,
		425
	],
	"./demo/LogoDark": [
		6686,
		686
	],
	"./demo/bet365/LogoDark": [
		3512,
		512
	],
	"./demo/bnq/LogoDark": [
		6218,
		218
	],
	"./demo/bupa/LogoDark": [
		5295,
		295
	],
	"./demo/rubicon/LogoDark": [
		7677,
		677
	],
	"./demo/screwfix/LogoDark": [
		7838,
		838
	],
	"./demo/test/LogoDark": [
		9949,
		949
	],
	"./demo/tfl/LogoDark": [
		4671,
		671
	],
	"./gravity/LogoDark": [
		3359,
		359
	],
	"./miroma/LogoDark": [
		2330,
		330
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7143;
module.exports = webpackAsyncContext;